export const colors = {
  black: "#30302D"
}